<template>
	<div>
		<div class="inventoryImages">
			<p v-if="images.length==0">{{count}}</p>
			<img
				v-for="(image,index) in images"
				v-bind:id="'thumbnail'+inventorypic_id+'-'+index"
				class="thumbnail"
				:style="'max-height:'+height"
				:alt="dir"
				v-on:click="imageClick(index)"
				v-bind:src="'data:image/jpg;base64,'+image"
			/>
		</div>
		<div v-bind:id="'myModal'+inventorypic_id" class="modal" v-on:click="close">
			<img v-bind:id="'img'+inventorypic_id" class="modal-content"/>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		inventorypic_id: String,
		count:String,
		height:String,
		imageCount:Number,
    },
	data() {
		return {
			images:[],
			imageData:[]
		}
	},
	mounted () {
		this.setInventorypic();
	},
	methods:{
		async setInventorypic(){
			if(this.inventorypic_id!=''&&this.inventorypic_id!=NaN&&this.inventorypic_id!=undefined){
				api.getInventoryPic(
	                {
						data:{
							filename:this.inventorypic_id,
							limit:this.imageCount,
						}
	                }
	            ).then((res) => {
					this.images = [];
					this.imageData = [];

					for(var i = 0;i<res.data.images.length;i++){
						this.images.push(res.data.images[i].image)
						this.imageData.push(res.data.images[i].data)
					}
		        });
			}
		},
		async imageClick(index){
			var modal = document.getElementById("myModal"+this.inventorypic_id);
			var modalImg = document.getElementById("img"+this.inventorypic_id);
			modalImg.src="data:image/jpg;base64,"+this.images[index];
			modal.style.display = "block";

			api.getInventoryPic(
				{
					data:{
						inventoryfilename:this.imageData[index]
					}
				}
			).then((res) => {
				modalImg.src="data:image/jpg;base64,"+res.data;
			});

		},
		async close(){
			var modal = document.getElementById("myModal"+this.inventorypic_id);
			modal.style.display = "none";
		},
	},
}
</script>

<style scoped>
.subtext{
	font-size: 12px;
	font-weight: normal;
	display:flex;
	flex-wrap: wrap;
	justify-content:left;
}

.thumbnail{
	max-width:100%;
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 5px;
	cursor: pointer;
	transition-duration: 0.4s;
}
.thumbnail:hover {opacity: 0.7;}

.modal {
	display: absolute;
	position: fixed;
	z-index: 5;
	padding-top: 100px;
	left: 0;
	top: 0;
	height:100%;
	overflow:auto;
	background-color: rgba(0,0,0,0.9);
}

.modal-content {
	margin: auto;
	max-height:90%;
	max-width:90%;
	display: block;
	object-fit:contain;
	background-color: rgba(0,0,0,0);
	animation:zoom 0.1s;
}

@keyframes zoom {
	from {transform:scale(0.5)}
	to {transform:scale(1)}
}

.inventoryImages{
	display:inline-block;
	width:100%;
}
</style>



// WEBPACK FOOTER //
// src/layouts/inventorypics.vue